(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
//Routing
module.exports.Config = function($routeProvider) {
  $routeProvider
    // route for the Dashboard
    .when("/", {
      template: "<dashboard></dashboard>",
      page: {
        title: "Dashboard"
      }
    });
};

},{}],2:[function(require,module,exports){
(function() {
  "use strict";

  angular.module("UsersApp.AdminModule", []);

  // Components and Angular Imports
  const AdminConfig = require("./admin.config");
  const Dashboard = require("./dashboard/dashboard");

  // Admin Config
  angular
    .module("UsersApp.AdminModule")
    .config(["$routeProvider", AdminConfig.Config]);
    
  // Directives
  angular
    .module("UsersApp.AdminModule")
    .directive("dashboard", Dashboard.Directive);
})();

},{"./admin.config":1,"./dashboard/dashboard":3}],3:[function(require,module,exports){
module.exports.Directive = function() {
  return {
    restrict: "E",
    scope: {},
    templateUrl: "/modules/admin/dashboard/dashboard.view.html"
  };
};

},{}],4:[function(require,module,exports){
require("./admin/admin.module");
require("./user/user.module");
require("./common/common.module");
require('./helpers/helpers.module');

(function() {
  "use strict";

  angular.module("UsersApp", [
    "ngRoute",
    "UsersApp.Partials",
    "UsersApp.AdminModule",
    "UsersApp.UsersModule",
    "UsersApp.CommonModule",
    "UsersApp.Helpers"
  ]);

  // Components and Angular Imports
  const App = require("./app/app");

  // Directives
  angular.module("UsersApp").directive("app", App.Directive);
})();

},{"./admin/admin.module":2,"./app/app":5,"./common/common.module":6,"./helpers/helpers.module":9,"./user/user.module":12}],5:[function(require,module,exports){
module.exports.Directive = function() {
  return {
    restrict: "E",
    scope: {},
    templateUrl: "/modules/app/app.view.html"
  };
};

},{}],6:[function(require,module,exports){
(function() {
  "use strict";

  angular.module("UsersApp.CommonModule", []);

  const Header = require("./header-component/header");
  const Footer = require("./footer-component/footer");

  /**
   * Directives
   */
  angular
    .module("UsersApp.CommonModule")
    .directive("headerComponent", Header.Directive);
  angular
    .module("UsersApp.CommonModule")
    .directive("footerComponent", Footer.Directive);
})();

},{"./footer-component/footer":7,"./header-component/header":8}],7:[function(require,module,exports){
module.exports.Directive = function() {
    return {
      restrict: "E",
      scope: {},
      templateUrl: "/modules/common/footer-component/footer-component.view.html"
    };
  };

},{}],8:[function(require,module,exports){
module.exports.Directive = function() {
  return {
    restrict: "E",
    scope: {},
    templateUrl: "/modules/common/header-component/header-component.view.html"
  };
};

},{}],9:[function(require,module,exports){
require("./services/Json2Csv.service");

(function() {
  "use strict";

  angular.module("UsersApp.Helpers", ["UsersApp.Helpers.Json2Csv"]);

})();

},{"./services/Json2Csv.service":10}],10:[function(require,module,exports){
(function() {
  "use strict";

  angular.module("UsersApp.Helpers.Json2Csv", []);

  angular.module("UsersApp.Helpers.Json2Csv").service("Json2Csv", Json2Csv);

  function Json2Csv() {
    // Json2Csv JSON data as CSV
    this.download = function(data) {
      if (!data.length) return;

      // Format Data
      let titles = Object.keys(data[0]).join(",") + "\r\n";

      let content = data.map(row => Object.values(row).join(";")).join("\r\n");

      let csv = titles + content;

      // Create CSV file and Download
      let link = document.createElement("a");
      link.id = "lnkDwnldLnk";
      document.body.appendChild(link);

      let blob = new Blob([csv], { type: "text/csv" });
      let csvUrl = window.webkitURL.createObjectURL(blob);
      let filename = "UserExport.csv";
      jQuery("#lnkDwnldLnk").attr({
        download: filename,
        href: csvUrl
      });

      jQuery("#lnkDwnldLnk")[0].click();
      document.body.removeChild(link);
    };
  }
})();

},{}],11:[function(require,module,exports){
//Routing
module.exports.Config = [
  "$routeProvider",
  function($routeProvider) {
    $routeProvider
      // route for the Dashboard
      .when("/users", {
        template: "<users></users>",
        page: {
          title: "Users"
        }
      })
      .when("/users/:id", {
        template: "<user-detials></user-detials>",
        page: {
          title: "User Details"
        }
      });
  }
];

},{}],12:[function(require,module,exports){
require("./users.api");
require("./users.data");

(function() {
  "use strict";

  angular.module("UsersApp.UsersModule", ["UsersApp.UsersModule.Api", "UsersApp.UsersModule.Data"]);

  // Components and Angular Imports
  const UserConfig = require("./user.config");
  const UsersComponent = require("./users/users");
  const UserRowComponent = require("./users/user-row/user-row");
  const UserDetailsComponent = require("./users-detials/users-detials");
  const UserShowComponent = require("./users/user-show/user-show");

  // Admin Config
  angular.module("UsersApp.UsersModule").config(UserConfig.Config);

  // Directives
  angular.module("UsersApp.UsersModule").directive("users", UsersComponent.Directive);
  angular.module("UsersApp.UsersModule").directive("userRow", UserRowComponent.Directive);
  angular.module("UsersApp.UsersModule").directive("userDetials", UserDetailsComponent.Directive);
  angular.module("UsersApp.UsersModule").directive("userShow", UserShowComponent.Directive);
})();

},{"./user.config":11,"./users-detials/users-detials":13,"./users.api":14,"./users.data":15,"./users/user-row/user-row":16,"./users/user-show/user-show":17,"./users/users":18}],13:[function(require,module,exports){
// Directive
function Directive() {
  return {
    restrict: "E",
    scope: {},
    controller: Controller,
    templateUrl: "/modules/user/users-detials/users-detials.view.html"
  };
}

// Controller
Controller.$inject = ["$scope", "$routeParams", "$location", "UsersData"];
function Controller($scope, $routeParams, $location, UsersData) {
  $scope.user = {};
  $scope.saveUser = saveUser;
  $scope.checkEdits = checkEdits;
  $scope.cancelEdits = cancelEdits;

  this.$onInit = function() {
    UsersData.getUserById($routeParams.id).then(function(response) {
      $scope.user = Object.assign({}, response.data);
    });
  };

  // Save User
  function saveUser() {
    UsersData.saveUser($scope.user);
    $location.url("/users");
  }

  // Cancel Edits
  function checkEdits() {
    if ($scope.editUser.$dirty) {
      jQuery("#cancelUserEdit").modal("show");
    }
  }

  // Cancel Edits
  function cancelEdits() {
    jQuery("#cancelUserEdit").modal("hide");
    $location.url("/users");
  }
}

module.exports.Directive = Directive;
module.exports.Controller = Controller;

},{}],14:[function(require,module,exports){
(function() {
  "use strict";
  angular.module("UsersApp.UsersModule.Api", []);

  // Services
  angular.module("UsersApp.UsersModule.Api").service("UsersAPI", UsersAPI);

  // Services Implementation
  UsersAPI.$inject = ["$http"];
  function UsersAPI($http) {
    // Get Users Data
    this.getUsers = function() {
      return $http({
        method: "GET",
        url: "/assets/data/users.json",
        headers: {
          "Content-Type": "application/json"
        }
      });
    };
  }
})();

},{}],15:[function(require,module,exports){
(function() {
  "use strict";
  angular.module("UsersApp.UsersModule.Data", ["UsersApp.UsersModule.Api"]);

  // Services
  angular.module("UsersApp.UsersModule.Data").service("UsersData", UsersData);

  // Services Implementation
  UsersData.$inject = ["$q", "UsersAPI"];
  function UsersData($q, UsersAPI) {
    // Users Data
    this.users = [];

    // Show User
    this.shownUser = {};

    // Get the Users
    this.getUsers = function() {
      // If there are users, return them
      if (this.users.length) {
        return $q.resolve({
          data: this.users
        });
      }

      // Get Users if no users were found
      return UsersAPI.getUsers().then(response => {
        this.users = response.data;
        return response;
      });
    };

    // Get User by Id
    this.getUserById = function(user_id) {
      return this.getUsers().then(function(response) {
        response.data = response.data.find(user => user.id == user_id);
        return response;
      });
    };

    // Save User
    this.saveUser = function(newUser) {
      for (let userIndex in this.users) {
        if (this.users[userIndex].id === newUser.id) {
          this.users[userIndex] = newUser;
          break;
        }
      }
    };

    // Delete User
    this.deleteUser = function(user_id) {
      this.users = this.users.filter(user => user.id !== user_id);
    };

    // Delete Multiple users once
    this.patchDelete = function(users) {
      let user_ids = users.map(user => user.id);
      this.users = this.users.filter(user => !user_ids.includes(user.id));
    }
  }
})();

},{}],16:[function(require,module,exports){
// Directive
function Directive() {
  return {
    restrict: "EA",
    scope: {
      user: "="
    },
    controller: Controller,
    templateUrl: "/modules/user/users/user-row/user-row.view.html"
  };
}

// Controller
Controller.$inject = ["$scope", "$location", "UsersData"];
function Controller($scope, $location, UsersData) {
  $scope.showUser = showUser;
  $scope.editUser = editUser;
  $scope.deleteUser = deleteUser;

  // Show User Data
  function showUser() {
    UsersData.shownUser = $scope.user;
    jQuery("#userDetailsModal").modal("show");
  }

  // Edit User
  function editUser() {
    $location.url("/users/" + $scope.user.id);
  }

  // Delete User
  function deleteUser() {
    UsersData.deleteUser($scope.user.id);
  }
}

module.exports.Directive = Directive;
module.exports.Controller = Controller;

},{}],17:[function(require,module,exports){
// Directive
function Directive() {
  return {
    restrict: "E",
    scope: {},
    controller: Controller,
    templateUrl: "/modules/user/users/user-show/user-show.view.html"
  };
}

// Controller
Controller.$inject = ["$scope", "UsersData"];
function Controller($scope, UsersData) {
  $scope.UserData = UsersData;
  $scope.calculateAge = calculateAge;

  // Calculates User Age
  function calculateAge() {
    if (!$scope.UserData.shownUser.dateOfBirth) return 0;

    let birthDate = new Date($scope.UserData.shownUser.dateOfBirth);
    let now = new Date();
    let diff = now.getFullYear() - birthDate.getFullYear();
    return Math.ceil(diff);
  }
}

module.exports.Directive = Directive;
module.exports.Controller = Controller;

},{}],18:[function(require,module,exports){
// Directive
function Directive() {
  return {
    restrict: "E",
    scope: {},
    controller: Controller,
    templateUrl: "/modules/user/users/users.view.html"
  };
}

// Controller
Controller.$inject = ["$scope", "UsersData", "Json2Csv"];
function Controller($scope, UsersData, Json2Csv) {
  $scope.users = [];
  $scope.currentPage = 0;
  $scope.getUsersPage = getUsersPage;
  $scope.previousPage = previousPage;
  $scope.nextPage = nextPage;
  $scope.isLastPage = isLastPage;
  $scope.getSelectedUsers = getSelectedUsers;
  $scope.isUserSelected = isUserSelected;
  $scope.deleteSelected = deleteSelected;
  $scope.downloadSelected = downloadSelected;

  const RowPerPage = 10;

  // Initialization
  this.$onInit = function() {
    getUsers();
  };

  // Get the Users from the API
  function getUsers() {
    UsersData.getUsers();
  }

  // Get the records for the current page
  function getUsersPage() {
    return UsersData.users.slice($scope.currentPage * RowPerPage, $scope.currentPage * RowPerPage + RowPerPage);
  }

  // Previous Page
  function previousPage() {
    let lastPageNumber = Math.ceil(UsersData.users.length / RowPerPage);
    $scope.currentPage = $scope.currentPage === 0 ? $scope.currentPage : $scope.currentPage - 1;
  }

  // Next Page
  function nextPage() {
    let lastPageNumber = Math.ceil(UsersData.users.length / RowPerPage);
    $scope.currentPage = isLastPage() ? $scope.currentPage : $scope.currentPage + 1;
  }

  // Chech if this is the last page
  function isLastPage() {
    let lastPageNumber = Math.ceil(UsersData.users.length / RowPerPage);
    return $scope.currentPage === lastPageNumber - 1;
  }

  // Check if any user are selected
  function isUserSelected() {
    return !!UsersData.users.find(user => user.selected);
  }

  // Get Selected Users
  function getSelectedUsers() {
    return UsersData.users.filter(user => user.selected);
  }

  //Delete Selected Rows
  function deleteSelected() {
    UsersData.patchDelete(getSelectedUsers());
  }

  // Download Selected Rows
  function downloadSelected() {
    // Clean Data
    let cleanData = JSON.parse(JSON.stringify(getSelectedUsers()));
    cleanData = cleanData.map(data => {
      delete data.$$hashKey;
      delete data.selected;
      return data;
    });

    // Download CSV file
    Json2Csv.download(cleanData);
  }
}

// Exports
module.exports.Directive = Directive;
module.exports.Controller = Controller;

},{}]},{},[4])

